import styled from 'styled-components';
import {
  mq,
  getSpace,
  gridContainer,
  setGridColumns,
  px2rem,
  getGridSpan,
  getGridSpans,
  getTextType
} from '../../../stylesheets/tools';

const StyledEventList = styled.div`
  .event-list__hero-container {
    ${gridContainer()};
    align-items: center;
    gap: ${px2rem('80px')};
    ${setGridColumns('1fr', 1, {
      l: ['1fr', 2]
    })};

    .event-list__teaser {
      width: 100%;
      margin-top: auto;
      margin-bottom: 0px;
      border: 2px solid;
      background: #ffffff;
      margin-left: 0;
    }

    .event-list__topic-copy {
      margin-top: ${getSpace('l')};
      margin-left: ${getGridSpan(1, 'spread')};
      ${getGridSpans('width', { m: 10 })}
    }

    .event-list__topic-link {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-top: ${getSpace('l')};

      svg {
        height: 20px;
        width: auto;
      }
    }
  }
  .event-list__event-container {
    padding-top: ${getSpace('l')};
    
    ${mq('m')} {
      padding-top: ${getSpace('xxxl')};
    }
  }
  .dateLine {
    display: flex;
    position: relative;
    align-items: center;
    margin-top: ${getSpace('m')};
    margin-bottom: ${getSpace('s')};

    ${mq('m')} {
      margin-top: ${getSpace('l')};
      margin-bottom: ${getSpace('m')};
    }

    .dateLine__stretched {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
  .dateLine__date {
    position: relative;
    ${getTextType('secondary')};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #000;
    height: 38px;
    aspect-ratio: 1/1;
    border-radius: 1px
    background-color: transparent;
    background-image: linear-gradient(180deg, currentColor, currentColor), linear-gradient(225deg, currentColor, currentColor),
      linear-gradient(0deg, currentColor, currentColor), linear-gradient(90deg, currentColor, currentColor),
      linear-gradient(135deg, transparent 6px, currentColor 6px, currentColor 8px, transparent 8px);
    background-position: top right, top right, bottom left, bottom left, top left;
    background-size: calc(100% - 8px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 8px), 10px 10px;
    background-repeat: no-repeat;
    
    ${mq('m')} {
      border-radius: 2px
      background-color: transparent;
      background-image: linear-gradient(180deg, currentColor, currentColor), linear-gradient(225deg, currentColor, currentColor),
      linear-gradient(0deg, currentColor, currentColor), linear-gradient(90deg, currentColor, currentColor),
      linear-gradient(135deg, transparent 9px, currentColor 9px, currentColor 12px, transparent 12px);
      background-position: top right, top right, bottom left, bottom left, top left;
      background-size: calc(100% - 13px) 3px, 3px 100%, 100% 3px, 3px calc(100% - 13px), 120px 120px;
      background-repeat: no-repeat;
      height: 54px;
      font-size: 30px;
    }
  }

  .dateLine__toggle svg {
    transition: all 0.25s ease-in-out;
  }
  .dateLine__toggle--active svg {
    transform: rotate(180deg);
  }

  .dateLine__line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px ${getSpace('xxs')} 10px ${getSpace('xxs')};
    width: 100%;
    background: ${props => props.theme.siteTheme.secondary};
    clip-path: polygon(
      0% 0%,
      calc(100% - 6px) 0%,
      100% 6px,
      100% 100%,
      100% 100%,
      0% 100%,
      0% 100%,
      0% 0%
    );

    ${mq('m')} {
      padding: ${getSpace('xxs')} ${getSpace('xs')} ${getSpace('xxs')} ${getSpace('xxs')};
      clip-path: polygon(
        0% 0%,
        calc(100% - 10px) 0%,
        100% 10px,
        100% 100%,
        100% 100%,
        0% 100%,
        0% 100%,
        0% 0%
      );
    }

    .dateLine__content {
      position: relative;
    }
    span {
      margin: 0;
      text-transform: unset;
      color: #000;
    }
  }
`;

export default StyledEventList;
